import { defineMessages } from 'react-intl-next';

export default defineMessages({
    label: {
        defaultMessage: 'Password',
        description: 'Label for password field',
        id: 'password.field.label',
    },
    showPassword: {
        defaultMessage: 'Show',
        description: 'Label for show password button',
        id: 'password.show.button.label',
    },
    hidePassword: {
        defaultMessage: 'Hide',
        description: 'Label for hide password button',
        id: 'password.hide.button.label',
    },
});
